<ng-container *ngIf="state$ | async as state">
  <div *ngIf="(state.isForUs) || (state.isForAu)" [ngClass]="{'tw-mt-8': addMargin}" class="tw-flex tw-flex-col md:tw-flex-row md:tw-justify-between md:tw-items-center lg:tw-items-start lg:tw-flex-col lg:tw-justify-center">
    <h4 class="tw-m-0">{{ 'payment.header' | cxTranslate }}</h4>
    <div>
      <ng-container *ngIf="state.isForUs">
        <img
          src="../../../assets/icons/payment_icons/amex_icon.svg"
          class="tw-mr-2 tw-mt-2"
          width="60"
          title="AMEX"
          alt="AMEX"
          aria-label="AMEX"
          data-cy="amex-icon"/>
        <img
          src="../../../assets/icons/payment_icons/visa_icon.svg"
          class="tw-mr-2 tw-mt-2"
          width="60"
          title="VISA"
          alt="VISA"
          aria-label="VISA"
          data-cy="visa-icon"/>
        <img
          src="../../../assets/icons/payment_icons/mastercard_icon.svg"
          class="tw-mr-2 tw-mt-2"
          width="60"
          title="MASTERCARD"
          alt="MASTERCARD"
          aria-label="MASTERCARD"
          data-cy="mastercard-icon"/>
      </ng-container>
      <img *ngIf="state.isForAu"
           src="../../../assets/icons/payment_icons/invoice_icon.svg"
           class="tw-mr-2 tw-mt-2"
           width="60"
           title="INVOICE"
           alt="INVOICE"
           aria-label="INVOICE"
           data-cy="invoice-icon"/>

      <img *ngIf="(state.isForUs) || (state.isForAu)"
           src="../../../assets/icons/payment_icons/po_icon.svg"
           class="tw-mr-2 tw-mt-2"
           width="60"
           title="PO-UPLOAD"
           alt="PO-UPLOAD"
           aria-label="PO-UPLOAD"
           data-cy="po-upload-icon"/>
    </div>
  </div>
</ng-container>
